import { graphQLRequest } from "@/libs/graphql/graphQLRequest";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { GetChargingPoolOffersQuery } from "../api/getChargingPoolOffers.graphql";
import { sortOffersByType } from "../utils/sortOffersByType";
import { CHARGING_POOL_QUERY_KEYS } from "./keys";

export const chargingPoolOffersQueryOptions = (chargingPoolId: string) =>
	queryOptions({
		queryKey: [CHARGING_POOL_QUERY_KEYS.GET_CHARGING_POOL_OFFERS, chargingPoolId],
		queryFn: () => graphQLRequest(GetChargingPoolOffersQuery, { input: { chargingPoolId } }),
	});

export const useChargingPoolOffersSuspenseQuery = (chargingPoolId: string) =>
	useSuspenseQuery({
		...chargingPoolOffersQueryOptions(chargingPoolId),
		select: (data) => sortOffersByType(data?.chargingPoolOffers?.offers ?? []),
	});
